import { render, staticRenderFns } from "./TotalQuotationsIssued.vue?vue&type=template&id=80143a06&scoped=true&"
import script from "./TotalQuotationsIssued.vue?vue&type=script&lang=js&"
export * from "./TotalQuotationsIssued.vue?vue&type=script&lang=js&"
import style0 from "./TotalQuotationsIssued.vue?vue&type=style&index=0&id=80143a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80143a06",
  null
  
)

component.options.__file = "TotalQuotationsIssued.vue"
export default component.exports